import { DashboardContainer } from "@forwardflow/components/Dashboard";
import { ActivateCampaign } from "@forwardflow/components/Campaign/ActivateCampaign";
const ActivateCampaignPage = () => {
  return (
    <>
      <DashboardContainer>
        <ActivateCampaign />
      </DashboardContainer>
    </>
  );
};

export default ActivateCampaignPage;
